export default __webpack_public_path__ + "static/media/1.0c7eab1d.jpg";